<template>
  <div class="container">
    <main class="sub-content">
      <div v-if="!isModal" class="tit"><RouteBack/>ATM 이상신고</div>
      <article class="sub">
        <section class="box-bg search-area">
          <div class="row row_jsa">
            <dl>
              <dt>등록일</dt>
              <dd>
                <DxDateBox
                  v-model="searchData.startDate"
                  :max="searchData.endDate"
                  display-format="yyyy-MM-dd"
                  styling-mode="outlined"
                  placeholder="from"
                />
              </dd>
              <dd>
                <DxDateBox
                  v-model="searchData.endDate"
                  :min="searchData.startDate"
                  display-format="yyyy-MM-dd"
                  styling-mode="outlined"
                  placeholder="to"
                />
              </dd>
            </dl>

          </div>
          <div class="taC">
            <a class="btn bg-default" @click="handleSearch(true)">조회</a>
            <a v-if="!isModal" class="btn bg-default" @click="handleCreate()">등록</a>
          </div>
        </section>
      </article>
      <section id="AtmMntcHstr">
        <div class="tbl_comment">
          * 내가 등록한 신고 내역 / <strong><span style="background-color: #f5ff3661">음영</span></strong>은 관리자 처리내용이 있는 상태입니다.
        </div>
        <div>
          <div class="tbl2">
            <div class="table-container2">
              <div class="table-header2 table-row2">
                <div class="table-cell2">날짜</div>
                <div class="table-cell2">ATM이름</div>
                <div class="table-cell2">상태</div>
                <div class="table-cell2">장애타입</div>
                <div class="table-cell2">내용</div>
                <div class="table-cell2">이미지</div>
              </div>
              <div class="scrollable-tbody2">
                <div v-for="(data, dataIdx) in dataList" :key="data.atmObstRcvNum" class="table-row2" :style="{backgroundColor: !!data.prcsCtts ? '#f5ff3661' : '' }" @click="handleShowPrcsCttsMsg(dataIdx)">
                    <div class="table-cell2">{{data.atmObstOcrnDt}}</div>
                    <div class="table-cell2">{{data.atmNm}}</div>
                    <div class="table-cell2">{{data.atmObstStatNm}}</div>
                    <div class="table-cell2">{{data.atmObstTypeNm}}</div>
                    <div class="table-cell2">{{data.atmObstCtts}}</div>
                    <div class="table-cell2 image-cell2" style="color: green;" @click="handleVisibleImage(data.apndFlInfo)">
                      {{data.apndFlInfo ? '이미지 보기' : ''}}
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isImageVisible" class="image-viewer" style="padding-top: 50px;">
            <span class="close" style="top: 0; right: 10px;" @click="closeImgViewer">&times;</span>
            <div style="display: flex; overflow: scroll; height: 100%;">
              <div
                v-for="(imgUrl, imgIdx) in trgtImageUrls"
                :key="`img-${imgIdx}`"
                class="img_view_cover"
                :style="{marginRight: (imgIdx + 1) === trgtImageUrls.length ? '0px' : ''}"
              >
                <div class="img_view_header">
                  <span style="background-color: black; padding: 5px;">
                    {{ `${imgIdx + 1} / ${trgtImageUrls.length}` }}
                  </span>
                </div>
                <img class="modal-content" id="full-image" :src="imgUrl" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

import DxDateBox from 'devextreme-vue/date-box'
import {formatMessage} from 'devextreme/localization'
import { IMG_SERVER_URL } from '../customerCare'

import RouteBack from '@/components/RouteBack.vue'

export default {
  name: 'AtmMntcHstr',
  props: ['isModal'],
  components: {
    DxDateBox,
    RouteBack
  },
  data () {
    const vm = this
    return {
      jQuery,
      prefixUrl: '/api/purchase/customerCare',
      pagingData: {
        skip: 0,
        totalRowCount: 0,
        rowCount: 50
      },
      searchData: {
        // 화면이 열렸을때 검색조건 세팅하기
        startDate: moment().subtract(7, 'day').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        stat: '',
        type: '',
        condition: '',
        conditionText: ''
      },
      dataList: [],
      cacheSearchData: null,
      cachePagingData: null,
      imageUrl: '',
      trgtImageUrls: [],
      isImageVisible: false
    }
  },
  computed: {
    userNm () {
      return window.$store.getters['Login/getUserNm']
    }
  },
  methods: {
    formatMessage: formatMessage,
    async handleSearch (buttonClick) {
      if (buttonClick) {
        this.dataList = []
        this.pagingData.skip = 0
      }

      const params = {
        ...this.searchData,
        startDate: moment(this.searchData.startDate).format('yyyy-MM-DD'),
        endDate: moment(this.searchData.endDate).format('yyyy-MM-DD'),
        skip: this.pagingData.skip,
        take: this.pagingData.rowCount,
        condition: '3',
        conditionText: this.userNm
      }

      const {data} = await Vue.httpClient.post('/api/purchase/customerCare/atmObstHstrList', params)

      if (data.result.list.length > 0) {
        data.result.list.forEach(obj => {
          this.dataList.push(obj)
        })
        this.pagingData.skip = this.pagingData.skip + this.pagingData.rowCount
      }
    },
    handleCreate () {
      this.$router.push({name: 'AtmObstHstrInsert', params: {}})
    },
    handleVisibleImage (apndFlInfo) {
      if (apndFlInfo) {
        this.trgtImageUrls = apndFlInfo.split('/%/').map(url => {
          return IMG_SERVER_URL + url
        })

        this.imageUrl = IMG_SERVER_URL + apndFlInfo
        this.isImageVisible = true
      }
    },
    formatDate (value) {
      if (value) {
        return moment(value).format('yyyy-MM-DD HH:mm:SS')
      } else {
        return ''
      }
    },
    closeImgViewer () {
      this.isImageVisible = false
      this.trgtImageUrls = []
    },
    handleShowPrcsCttsMsg (trgtIdx) {
      const { prcsDt, prcsCtts } = this.dataList[trgtIdx]
      if (prcsCtts) {
        const formatPrcsDt = moment(prcsDt).format('yyyy-MM-DD HH:mm:SS')
        this.$Alert.alert(`등록일시 : ${formatPrcsDt}<br/>${prcsCtts}`)
      }
    }
  },
  mounted () {
    this.handleSearch()

    window.onscroll = () => {
      if ($(window).scrollTop() >= $(document).height() - $(window).height()) {
        // this.handleSearch()
      }
    }
  }
}

</script>

<style>
.boundary .dx-widget input {
  font-size: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/customerCare/AtmObstHstr.vue